module.exports = __webpack_public_path__ + "static/media/selo-fitch.de7a46bf.png";